import { NumericFormat } from 'react-number-format';
import NewCustomSelect from '../newcustomselect/newcustomselect';
import CustomCurrencyInput from '../input/CurrencyInput';

export interface paymentinputProps {
    currencies: any;
    label: string;
    loadingCurrencies: boolean;
    name: string;
    error: boolean;
    helperText?: string;
    currency: string;
    setCurrency: (value: string) => void;
    amount: number;
    setAmount: (value: number) => void;
}

export const NumberInput = (props: any) => {
    const { inputRef, onChange, value, ...other } = props;

    return (
        <NumericFormat
            {...other}
            value={value || ''}
            getInputRef={inputRef}
            onValueChange={(values) => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.value
                    }
                });
            }}
            thousandSeparator=','
            thousandsGroupStyle='thousand'
            valueIsNumericString
            decimalScale={2}
            fixedDecimalScale={false}
            allowNegative={false}
        />
    );
};

const Paymentinput = ({
    currencies,
    label,
    loadingCurrencies,
    name,
    error,
    helperText,
    currency,
    setCurrency,
    amount,
    setAmount
}: paymentinputProps) => {
    return (
        <div className='flex gap-[12px] items-center lg:max-w-[500px]'>
            <div className='flex-1'>
                <CustomCurrencyInput
                    label={label}
                    id={`${name}-payment-input`}
                    errorMessage={helperText}
                    required
                    name={name}
                    onValueChange={(val) => setAmount(Number(val))}
                    placeholder='0.00'
                    value={amount}
                    currency={currency}
                    isError={error}
                />
            </div>
            <div className='w-[96px]'>
                <NewCustomSelect
                    label='Currency'
                    selectValue={currency}
                    loading={loadingCurrencies}
                    showSearch={true}
                    name={'select'}
                    updateField={(_, value) => setCurrency(value)}
                    selectOptions={currencies}
                    selectOptionLabel='nameAndFlag'
                    alternativeValue='currencyCode'
                />
            </div>
        </div>
    );
};

export default Paymentinput;
